/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';

import { Icon, Button } from 'components/ClubComponents';
import { I18n } from 'components/translate';
import { URL, ZENDESK_LOCALE } from 'configs/constants';
import { BASE_MODULE, MODULE_WEBINAR } from 'configs/routes/constants';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import { ContentService } from 'modules/content';
import { MembershipEventService } from 'modules/membershipEvent';
import { EVENTS } from 'modules/membershipEvent/constants';
import PropTypes from 'prop-types';

import { ZENDESK_ARTICLES } from './constants';

import './ClubLive.scss';

const ClubLive = ({ history, locale }) => {
  const [closed, setClosed] = useState(false);
  const [itemId, setItemId] = useState('');
  const articleLink = `${URL.ZENDESK}/${ZENDESK_LOCALE[locale]}/${ZENDESK_ARTICLES.CLUB_LIVE}`;

  useEffect(() => {
    const getItemId = async () => {
      const item = await ContentService.getfirstModulePaid();

      setItemId(item);
    };

    getItemId();
  }, []);

  const sendEvent = (label) => {
    GtagService.sendEvent({
      event: GA.EVENTS.INTERACTION,
      category: GA.CATEGORIES.CLUB_ADMIN_MODAL,
      action: GA.ACTIONS.CLICK,
      where: GA.ACTIONS.NOTIFICATION_LIVE.LIVE_ANOUCEMENT,
      label
    });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.CONTENT_LIVE.LIVE_ANNOUNCEMENT_MODAL,
        action: EVENTS_INTERACTIONS.CLICK,
        label
      })
    });
  };

  const onDisable = (label) => {
    sendEvent(label);
    setClosed(true);
    MembershipEventService.dismissEvent(EVENTS.CLUB_LIVE);
  };

  const redirectOnboarding = () => {
    sendEvent(GA.LABELS.START_NOW_LIVE);
    MembershipEventService.dismissEvent(EVENTS.CLUB_LIVE);
    history.push(`${BASE_MODULE}/${itemId}/${MODULE_WEBINAR}/new`);
  };

  return (
    !closed && (
      <div className="notification__club__live">
        <button
          className="notification__club__live__close"
          onClick={() => onDisable(GA.LABELS.CLOSE)}
        >
          <Icon name="times" size={14} />
        </button>

        <span className="notification__club__live__title">
          <Icon name="live" size={Icon.SIZE.MEDIUM} />
          <I18n label="webinar_notification.club_live.title" />
        </span>

        <p className="notification__club__live__text">
          <I18n label="webinar_notification.club_live.description" />
          &nbsp;
          <a href={articleLink} target="_blank" rel="noopener noreferrer">
            <I18n label="webinar_notification.club_live.link" />
          </a>
        </p>

        <div className="notification__club__live__actions">
          <button
            className="notification__club__live__btn notification__club__live__btn-close"
            outline
            size={Button.SIZE.SMALL}
            onClick={() => onDisable(GA.LABELS.SEE_LATER)}
          >
            <I18n label="webinar_notification.club_live.dismiss_alert" />
          </button>

          <Button.Primary
            className="notification__club__live__btn"
            icon="live"
            size={Button.SIZE.SMALL}
            onClick={redirectOnboarding}
          >
            <I18n label="webinar_notification.club_live.create_webinar" />
          </Button.Primary>
        </div>
      </div>
    )
  );
};

ClubLive.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  locale: PropTypes.string.isRequired
};

export default withRouter(ClubLive);
